import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteGroupAlumni",
  tabindex: "-1",
  "aria-labelledby": "deleteGroupAlumni",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroupAlumni"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-center my-3 mx-3" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "modal fade",
  id: "deleteGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteGroupSuccess",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "modal-dialog" }
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = { class: "modal-header" }
const _hoisted_14 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroupSuccess"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_16 = { class: "modal-body d-flex justify-content-center" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  class: "modal fade",
  id: "deleteGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteGroupSuccess",
  "aria-hidden": "true",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_19 = { class: "modal-dialog" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroupSuccess"
}
const _hoisted_23 = { class: "modal-body d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'

import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { GROUPS_STORE, ROOT_STORE } from '@/store/constants'
import { computed, onMounted, ref } from 'vue'

import { useRoute, useRouter } from 'vue-router'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  groupId: String,
  groupName: String,
  // 2022/09/30 CW-Phuong Fix for UAT Phase2#4473: SN10 (Ph2-R20220930)
  paramGetGroup: Object,
},
  setup(__props) {

const props = __props

const route = useRoute()
const router = useRouter()

const deleteFailed = ref<boolean>(false)
const store = useStore()
const loadingDelete = ref<boolean>(false)
const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])



// 2022/09/12 TienNV Fix double click button confirm delete group
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('deleteGroupAlumni'))
  modalSuccess.value = new Modal(document.getElementById('deleteGroupSuccess'))
})

const routePath = `${route.path.split('/')[1]}/communities/${route.params.id}/groups/${route.params.group_id}`

const DeleteAGroup = async () => {
  loadingDelete.value = true
  try {
    const response = await groupsService.deleteGroupApi(props.groupId)
    if (response?.status === 200) {
      deleteFailed.value = false
      // 2022/09/30 CW-Phuong Fix for UAT Phase2#4473: SN10 (Ph2-R20220930)
      if (route.path !== `/${routePath}/users` && route.path !== `/${routePath}/talk_rooms` && route.path !== `/${routePath}/talk_rooms/${route.params.talkroom_id}`) {
        const dataGroup = await groupsService.getGroupsApi(props.paramGetGroup.id, props.paramGetGroup.params)
        store.dispatch(GROUPS_STORE.ACTIONS.DELETE_GROUPS, { id: props.groupId, dataGroup: dataGroup.data })
      }
    } else {
      deleteFailed.value = true
    }
    // 2022/09/12 TienNV Fix double click button confirm delete group
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loadingDelete.value = false
    }, 2000)
  } catch (error) {
    deleteFailed.value = true
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loadingDelete.value = false
    console.log(error)
  }
}

const backToGroups = () => {
  if (!deleteFailed.value && route.path !== `/${route.path.split('/')[1]}/communities/${route.params.id}/groups`)
    router.push(`/${route.path.split('/')[1]}/communities/${route.params.id}/groups`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SN10headerDelete')), 1),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString('「' + __props.groupName + '」' + ' を削除します。'), 1),
            _createElementVNode("div", _hoisted_8, [
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    class: "me-2",
                    size: 'small',
                    className: 'fw-bold'
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(Button, {
                title: _unref(translate)('SO65delete'),
                onClick: DeleteAGroup,
                loading: loadingDelete.value,
                disabled: loadingDelete.value,
                type: 'secondary',
                size: 'small',
                className: 'fw-bold'
              }, null, 8, ["title", "loading", "disabled"]),
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(Button, {
                    key: 1,
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    class: "me-2",
                    size: 'small',
                    className: 'fw-bold'
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 32)
      ])
    ]),
    (
      _unref(route).path !== `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/users` &&
      _unref(route).path !== `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/talk_rooms`
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h5", _hoisted_14, _toDisplayString(deleteFailed.value ? _unref(translate)('errorDeleteGroupUser') : _unref(translate)('deleteHistorySuccess')), 1),
                  _hoisted_15
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(Button, {
                    title: _unref(translate)('close'),
                    type: 'secondary',
                    class: "me-2",
                    onClick: backToGroups,
                    "data-bs-dismiss": "modal",
                    size: 'small',
                    className: 'fw-bold'
                  }, null, 8, ["title"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (
      _unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/users` ||
      _unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/talk_rooms`
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("h5", _hoisted_22, _toDisplayString(deleteFailed.value ? _unref(translate)('errorDeleteGroupUser') : _unref(translate)('deleteHistorySuccess')), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(Button, {
                    title: _unref(translate)('close'),
                    type: 'secondary',
                    class: "me-2",
                    onClick: backToGroups,
                    "data-bs-dismiss": "modal",
                    size: 'small',
                    className: 'fw-bold'
                  }, null, 8, ["title"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})